import {
  Expertise001Image,
  Expertise002Image,
  Expertise003Image,
  Expertise004Image,
  Expertise005Image,
  Expertise006Image,
} from 'Assets/Image/Expertise'

import { ExpertiseItem, ExpertiseItemId } from './types'

export const EXPERTISE_ITEMS: ExpertiseItem[] = [
  {
    id: ExpertiseItemId.WebDevelopment,
    title: 'Web development',
    description:
      'From real-time interfaces to data-rich visuals, we craft web experiences that feel effortless and perform beyond expectations',
    illustration: Expertise001Image,
  },
  {
    id: ExpertiseItemId.AppDevelopment,
    title: 'App development',
    description:
      'Powered by a battle-tested system, we turn ideas into polished apps - fast to build, smooth to use, and easy to grow',
    illustration: Expertise002Image,
  },
  {
    id: ExpertiseItemId.UxUiDesign,
    title: 'UX/UI design',
    description:
      'Our design process balances beauty with logic - shaping intuitive, memorable products users enjoy from the first tap',
    illustration: Expertise003Image,
  },
  {
    id: ExpertiseItemId.AiTransformation,
    title: 'AI transformation',
    description:
      'Bring AI into your workflow to reduce costs, boost ROI, and stay ahead of changing market demands.',
    illustration: Expertise004Image,
  },
  {
    id: ExpertiseItemId.ItConsulting,
    title: 'IT Consulting',
    description:
      'To validate your idea or technology according to your business goals, we perform an architectural assessment, create solution designs, report on risks and limitations, and supply improvement roadmaps.',
    illustration: Expertise005Image,
  },
  {
    id: ExpertiseItemId.AuditCompliance,
    title: 'Audit & Compliance',
    description:
      'We audit backend, frontend (web & mobile), and infrastructure to identify risks, ensure code quality, and prepare you for ISO 27001, SOC 2, and HIPAA compliance.',
    illustration: Expertise006Image,
  },
]
